import './ErrorPage.scss';
export function ErrorPage() {
    return (
        <div className="ErrorPage">
            <div className="bg-overlay"></div>
            <img className="bg" src="assets/agriculture/repair-tractor-low-res.jpg" />
            <div className="content">
                <h1 className="text-center">Something Went Wrong!</h1>

                <p className="text-center">
                    This wasn’t in the plan, but we’re fixing it!  Check back soon - we’ll have
                    things running again shortly.
                </p>
                <p className="text-center">
                    Need assistance? Email &nbsp;
                    <a href="mailto:help@faarm.com.au">help@faarm.com.au</a>
                </p>
            </div>
        </div>
    );
}
